import { alpha, fontSize, fontWeight, maxWidth } from "@mui/system";

const styles = (theme) => ({
  containerPaper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    borderRadius: "16px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  containerHeader: {
    display: "flex",
    flexDirection: "column",
    padding: 2,
    gap: 1,
  },
  boxSelectTipo: {
    flex: 1,
    border: "1px solid",
    borderRadius: 1,
    padding: "8px 16px",
    transition: "all 0.2s ease",
    "&:hover": { borderColor: "primary.main" },
  },
  containerPaperModal: {
    width: "100%",
    borderRadius: "16px",
    padding: 2,
    overflowY: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    flexWrap: "wrap",
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
  },
  boxBodyModal: { margin: "0px 40px 0px 40px" },
  containerBodyModal: { maxHeight: "65%", overflowY: "auto" },
  titleDescription: {
    fontSize: "15px",
    fontWeight: "bold",

    display: "flex",
    alignItems: "center",
    gap: 0.5,
  },
  linearProgres: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  boxTextField: { position: "relative", width: "100%" },
  boxEdit: {
    width: "100%",
    display: "flex",
    alignItems: "center",

    justifyContent: "space-between",
    height: "50px",
    padding: "0 50px",
  },
  containerData: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  containerDataTenico: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    padding: 2,
  },
  titleData: { fontWeight: "bold", fontSize: "13px" },
  boxData: { display: "flex", flexDirection: "column", padding: 2 },
  boxHeader: { display: "flex", alignItems: "center", gap: 0.5 },
  boxDataTecnico: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    padding: 0.5,
  },
  boxImg: {
    width: "40px",
    height: "40px",
    objectFit: "cover",
    display: "block",
    borderRadius: "50%",
    overflow: "hidden",
    flexShrink: 0,
    flexGrow: 0,
  },
  boxWithoutImg: {
    width: "40px",
    height: "40px",

    display: "block",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  chip: {
    fontWeight: "bold",
    color: theme.palette.white.main,
    fontSize: "10px",
    textTransform: "capitalize",
    maxWidth: "160px",
  },
});

export default styles;
